import clsx from 'classnames';
import { useEffect } from 'react';
import SwiperCore from 'swiper';
import { Slider } from 'ui';
import { getCookie, setCookie } from 'utils';

import { ProductPageBanner } from '@/modules/product/api/banners';
import { BANNERS_STATE_COOKIE_NAME } from '@/modules/product/utils';
import { getBannerSlotName, renderBanner } from '@/shared/banners/utils';

import styles from './FullWidthBanners.module.scss';
import { imageBreakpoints } from './utils';

export function FullWidthBanners({
  banners,
  maxHeight = 200,
  name,
  initialSlide,
}: {
  banners: ProductPageBanner[];
  maxHeight?: number;
  name: 'inside_grid' | 'above_footer';
  initialSlide: number;
}) {
  const updateCookie = (slide: number) => {
    const bannerStateCookie = getCookie(BANNERS_STATE_COOKIE_NAME);

    if (!bannerStateCookie) {
      return;
    }

    const oldValue = JSON.parse(bannerStateCookie);

    const newValue = {
      ...oldValue,
      [name]: slide === banners.length - 1 ? 0 : slide + 1,
    };

    setCookie(BANNERS_STATE_COOKIE_NAME, JSON.stringify(newValue));
  };

  const handleSlideChange = (swiper: SwiperCore) => {
    updateCookie(swiper.realIndex);
  };

  useEffect(() => {
    updateCookie(initialSlide);
  }, []);

  if (banners.length === 0) {
    return null;
  }

  return (
    <div
      className={clsx('FullWidthBanners', styles.FullWidthBanners__wrapper)}
      style={{ '--max-height': `${maxHeight}px` } as React.CSSProperties}
    >
      <Slider
        hasArrows={banners.length > 1}
        initialSlide={initialSlide}
        loop
        onSlideChange={handleSlideChange}
        autoplay
      >
        {banners.map((banner, index) => (
          <div
            key={banner.productBannerId}
            className={styles.FullWidthBanners__slide}
          >
            {renderBanner(
              banner.layout,
              null,
              banner.name,
              index + 1,
              getBannerSlotName(banner.location),
              imageBreakpoints
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
}
